import { render, staticRenderFns } from "./PageSelfRoomSeat.vue?vue&type=template&id=70cd611e&scoped=true"
import script from "./PageSelfRoomSeat.vue?vue&type=script&lang=js"
export * from "./PageSelfRoomSeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd611e",
  null
  
)

export default component.exports